import React from "react";
import {IntlShape, injectIntl} from "react-intl";

import {ESopLicenses} from "@/components/license/models";
import license from "@/services/license";
import networkDevices from "@/services/network-devices";
import {IAdvancedSop} from "../models";

import ExecuteSop from "@shared/sop/ExecuteSop";

interface IFracExecuteProps {
    intl: IntlShape;
    sop: IAdvancedSop;
    messages?: React.RefObject<HTMLDivElement>;
    iconOnly?: boolean;
}

class FracExecute extends React.PureComponent<IFracExecuteProps> {
    private get executeUrl() {
        const {intl, sop} = this.props;

        if (!sop.executeUrl) {
            return undefined;
        }

        // copy from executeUrl CentExecute.tsx
        const queries = new URLSearchParams({
            language: intl.locale,
        });

        return `${sop.executeUrl}&${queries}`;
    }

    public render() {
        const {iconOnly, messages, sop} = this.props;
        const {sops} = license.status;
        const sopLicensed = license.getDeviceLicenses().frac;
        const deviceLicensed = networkDevices.isLicensed(sop.device);
        const unlimited =
            !sops.includes(ESopLicenses.FracUnlimitedDuration) &&
            sop.cycle.unlimited;
        const multiCycle =
            !sops.includes(ESopLicenses.FracMultiCycleStressCurveSOP) &&
            sop.cycle.cycles.length > 1;

        if (!sopLicensed || !deviceLicensed || unlimited || multiCycle) {
            return null;
        }

        return (
            <ExecuteSop
                executeUrl={this.executeUrl}
                iconOnly={iconOnly}
                messages={messages}
            />
        );
    }
}

export default injectIntl(FracExecute);
